Ext.define('SA.view.mixin.ChildItems', {
    getRefItems(deep) {
        var items = this.getChildItems(),
            result = [];

        if (!items) {
            return result;
        }

        items.forEach(item => {
            if (item) {
                result.push(item);

                if (deep && item.getRefItems) {
                    result.push.apply(result, item.getRefItems(true));
                }
            }
        });

        return result;
    }
});